import React, { Component } from "react";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      path: props.path || '',
      key: props.key || '',
      error: null
    };

    this.submitForm = this.submitForm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event)  {
    const target = event.target;

    this.setState({
      [target.name]: target.value
    });
  };

  async submitForm(e) {
    e.preventDefault();
    this.setState({ isLoading: true });

    try {
      if (this.props.handleLogin(e.target.password.value, e.target.username.value)) {
        this.setState({ isLoading: false });
        this.props.history.push('/');
      } else {
        this.setState({ isLoading: false, error: "error" });
      }
    } catch (e) {
      console.log(e);
      this.setState({ isLoading: false, error: null });
    }
  };

  render() {
    return (
      <div className="Login">
        <form onSubmit={this.submitForm}>
          <label htmlFor="username">Username</label>
          <input name="username" type="text" id="username" required="true"/>
          <label htmlFor="password">Password</label>
          <input name="password" type="text" id="password" required="true"/>
          <button type="submit" className="btn btn-primary">Submit</button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login.js